import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import {
  mapRestPlacesToCardItems,
  useSelectRestPlace,
} from 'features/kyrgyzstan/select-rest-place'

import { kyrgyzstanRestPlacesStore } from 'entities/kyrgyzstan/model'
import { RestPlacesGridLayout } from 'entities/kyrgyzstan/ui/rest-places-grid'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const KyrgyzstanRestPlacesPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    kyrgyzstanRestPlacesStore.loadIfNeeded()
  }, [])

  const places = kyrgyzstanRestPlacesStore.getRestPlaces()
  const title =
    kyrgyzstanRestPlacesStore.getTitle() ||
    t('kyrgyzstan_block.rest_places.title')
  const { isLoading } = kyrgyzstanRestPlacesStore
  const preparedPlaces = mapRestPlacesToCardItems(places)
  const handleSelectPlace = useSelectRestPlace(places)

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <div className={s.container}>
      <HeaderGoBack
        title={title}
        onGoBack={handleGoBack}
        buttonWhite
      />

      <div className={clsx('container', s.list)}>
        <RestPlacesGridLayout
          places={preparedPlaces}
          isLoading={isLoading}
          onSelectPlace={handleSelectPlace}
        />
      </div>
    </div>
  )
})

export default KyrgyzstanRestPlacesPage
